var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as shiftAction from '../actions/shift.action';
import { map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { ShiftService } from '../../shift.service';
var ShiftEffect = /** @class */ (function () {
    function ShiftEffect(actions, shiftService) {
        var _this = this;
        this.actions = actions;
        this.shiftService = shiftService;
        this.getAllShifts = this.actions.ofType(shiftAction.GET_ALL_SHIFTS)
            .pipe(map(function (action) { return action.payload; }), mergeMap(function (body) {
            return _this.shiftService.getPopupShifts(body.startDate, body.endDate)
                .map(function (r) { return new shiftAction.GetAllShiftsSuccess(r); })
                .catch(function (e) { return of(new shiftAction.GetAllShiftsFail(e)); });
        }));
        this.getShiftDetails = this.actions.ofType(shiftAction.GET_SHIFT_DETAILS)
            .pipe(map(function (action) { return action.payload; }), mergeMap(function (body) {
            return _this.shiftService.getShiftDetails(body)
                .map(function (r) { return new shiftAction.GetShiftDetailsSuccess(r); })
                .catch(function (e) { return of(new shiftAction.GetShiftDetailsError(e)); });
        }));
        this.createShift = this.actions.ofType(shiftAction.CREATE_SHIFT)
            .pipe(map(function (action) { return action.payload; }), mergeMap(function (body) {
            return _this.shiftService.createPopupShift(body)
                .map(function (r) { return new shiftAction.CreateShiftSuccess(r); })
                .catch(function (e) { return of(new shiftAction.CreateShiftFail(e)); });
        }));
        this.deleteShift = this.actions.ofType(shiftAction.DELETE_SHIFT)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.shiftService.deletePopupShift(body)
                .map(function (res) {
                return new shiftAction.DeleteShiftSuccess(res);
            })
                .catch(function (error) { return of(new shiftAction.DeleteShiftFail(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ShiftEffect.prototype, "getAllShifts", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ShiftEffect.prototype, "getShiftDetails", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ShiftEffect.prototype, "createShift", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ShiftEffect.prototype, "deleteShift", void 0);
    return ShiftEffect;
}());
export { ShiftEffect };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shifts/store/effects/shift.effect.ts.pre-build-optimizer.js